/** Loading placeholder mirroring the flat card-list layout. */
export function AutomationsSkeleton() {
  return (
    <div className="flex flex-col gap-3" aria-hidden>
      {[0, 1, 2].map((i) => (
        <div key={i} className="bg-card rounded-xl p-4">
          <div className="flex items-center gap-3">
            <div className="bg-muted h-4 w-24 animate-pulse rounded" />
            <div className="bg-muted h-6 w-6 animate-pulse rounded-full" />
            <div className="bg-muted ml-auto h-5 w-9 animate-pulse rounded-full" />
          </div>
          <div className="bg-muted mt-2 h-3 w-40 animate-pulse rounded" />
        </div>
      ))}
    </div>
  )
}
